import { inject, InjectionToken, Provider } from '@angular/core';
import { SubmissionListSignalState } from '@data-access/submissions/types';
import { SUBMISSIONS_LIST_SIGNAL_STORE } from '../signal-stores/submission-list.signal-store';;

export const SUBMISSION_LIST_TOKEN =
  new InjectionToken<SubmissionListSignalState>('Submissions List');

export const SUBMISSION_LIST_PROVIDER: Provider = {
  provide: SUBMISSION_LIST_TOKEN,
  useClass: SUBMISSIONS_LIST_SIGNAL_STORE,
};

export function submissionListTokenizer() {
  return inject(SUBMISSION_LIST_TOKEN);
}